import { Illustration, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { SupportContext } from "@src/appV2/support/constants";
import { HowToContactSupportLink } from "@src/appV2/support/HowToContactSupportLink";

import { PageWrapper } from "../components/PageWrapper";
import { StickyScrollPageHeader } from "../components/StickyScrollPageHeader";

export interface ErrorPageProps {
  title: string;
  description?: string;
}

export function DocumentsErrorPage(props: ErrorPageProps) {
  const { title, description } = props;

  return (
    <PageWrapper variant="tertiary">
      <StickyScrollPageHeader title={title} headerVariant="tertiary" />

      <Stack
        direction="column"
        spacing={7}
        sx={{
          padding: 5,
          flex: 1,
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {isDefined(description) && <Text>{description}</Text>}

        <Illustration type="document-rejected" />

        <Text sx={{ mb: 2 }}>
          If you keep having trouble, please reach out to our Support team.
        </Text>

        <HowToContactSupportLink supportContext={SupportContext.DOCUMENTS_ERROR} />
      </Stack>
    </PageWrapper>
  );
}
